'use strict';

angular.module('atex.dam').factory('DamRestrictContentService', ['$rootScope', '$q', '$translate', '$http', 'ApplicationConfigurationService', 'AuthenticationService', 'ContentCacheService', 'ContentService', 'ContentConfigurationService', 'DamNotificationService',
  function ($rootScope, $q, $translate, $http, ApplicationConfigurationService, AuthenticationService, ContentCacheService, ContentService, ContentConfigurationService, DamNotificationService) {

    var wrapCall = function(fn) {
      return ApplicationConfigurationService.getConfigurationFor(['oneCMSUrl']).then(function(oneCMSUrl) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return fn({
            oneCMSUrl: oneCMSUrl,
            currentUser: currentUser,
            httpConfig: {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Auth-Token': currentUser.token
              }
            }
          });
        });
      });
    };

    var damRestrictService = {
      restrictContent: function(id) {
        return wrapCall(function (config) {
          var url = config.oneCMSUrl + "/dam/content/restrict/" + encodeURIComponent(id);
          return $http(_.extend(config.httpConfig, {
            method: 'POST',
            url: url
          })).then(function(response) {
            return response.data;
          });
        });
      },
      unRestrictContent: function(id) {
        return wrapCall(function (config) {
          var url = config.oneCMSUrl + "/dam/content/unrestrict/" + encodeURIComponent(id);
          return $http(_.extend(config.httpConfig, {
            method: 'POST',
            url: url
          })).then(function(response) {
            return response.data;
          });
        });
      },
      canRestrictContent: function(id) {
        return wrapCall(function (config) {
          var url = config.oneCMSUrl + "/dam/content/canrestrict/" + encodeURIComponent(id);
          return $http(_.extend(config.httpConfig, {
            method: 'GET',
            url: url
          })).then(function(response) {
            return response.data;
          });
        });
      },
      canUnRestrictContent: function(id) {
        return wrapCall(function (config) {
          var url = config.oneCMSUrl + "/dam/content/canunrestrict/" + encodeURIComponent(id);
          return $http(_.extend(config.httpConfig, {
            method: 'GET',
            url: url
          })).then(function(response) {
            return response.data;
          });
        });
      }
    };

    var notifyMsg = function(msg, type) {
      return $translate([msg]).then(function (translations) {
        return DamNotificationService.addNotification(atex.dam.Notification({
          type: type,
          persistent: false,
          message: translations[msg] || msg
        }), false);
      });
    };

    var notifyError = function(msg) {
      return notifyMsg(msg, 'error');
    };

    var notifyWarning = function(msg) {
      return notifyMsg(msg, 'warning');
    };

    var notifySuccess = function(msg) {
      return notifyMsg(msg, 'success');
    };

    var errorFromService = function (msg, error) {
      var errorText = (error.rootCause || {}).errorThrown || error.cause || error.statusText;
      return $translate([msg]).then(function (translations) {
        notifyError(translations[msg] + " (" + errorText + ")");
      });
    };

    var notifyUpdate = function (id) {
      $rootScope.$broadcast('dam:updatedItem', {'id': id});
    };

    var updateSecurityParent = function(entry, isRestrict) {
      if (isRestrict) {
        return damRestrictService.restrictContent(entry.id).then(function(object) {
          notifyUpdate(object.id);
          return notifySuccess('__OPERATION_COMPLETED_SUCCESSFULLY__');

        }, function (error) {
          if ((error.data && error.data.statusCode === 41200) || error.status === 412) {
            return notifyWarning('Content has no security parent or no configuration found in atex.configuration.desk.restrictContent for the content security parent');
          }
          console.log('error restricting ' + entry.id, error);
          return errorFromService('__GENERIC_ERROR_MSG__', error);
        });
      } else {
        return damRestrictService.unRestrictContent(entry.id).then(function(object) {
          notifyUpdate(object.id);
          return notifySuccess('__OPERATION_COMPLETED_SUCCESSFULLY__');
        }, function (error) {
          if ((error.data && error.data.statusCode === 41200) || error.status === 412) {
            return notifyWarning('Content has no security parent or no configuration found in atex.configuration.desk.restrictContent for the content security parent');
          }
          console.log('error restricting ' + entry.id, error);
          return errorFromService('__GENERIC_ERROR_MSG__', error);
        });
      }
    };

    var canRestrictUnRestrictContent = function(entries, isRestrict) {
      if (entries !== undefined && entries.length > 0) {
        var promises = [];
        entries.forEach(function (entry) {
          if (isRestrict) {
            promises.push(damRestrictService.canRestrictContent(entry.id));
          } else {
            promises.push(damRestrictService.canUnRestrictContent(entry.id));
          }
        });
        return $q.all(promises).then(function(responses) {
          // if any of the responses is false, return false
          for (var i = 0; i < responses.length; i++) {
            if (!responses[i]) {
              return false;
            }
          }
          return true;
        });
      } else {
        return $q.when(false);
      }
    };

    return {
      restrictContent: function (entries) {
        if (entries !== undefined && entries.length > 0) {
          entries.forEach(function (entry) {
            updateSecurityParent(entry, true);
          });
        }
      },
      unRestrictContent: function (entries) {
        if (entries !== undefined && entries.length > 0) {
          entries.forEach(function (entry) {
            updateSecurityParent(entry, false);
          });
        }
      },
      canRestrictContent: function (entries) {
        return canRestrictUnRestrictContent(entries, true);
      },
      canUnRestrictContent: function (entries) {
        return canRestrictUnRestrictContent(entries, false);
      }
    };

  }]);